import * as React from "react";

function MedSvg(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={30.483}
      height={30.485}
      {...props}
    >
      <path
        d="M16.392 22.185l4.507-4.507v-6.052a2.683 2.683 0 00-2.7-2.517h-1.115V7.085h.589a1.822 1.822 0 001.793-1.757V1.871A1.909 1.909 0 0017.677 0h-2.325v5.3h-1.786V0h-2.194v5.3H9.584V0H7.248v5.3H5.462V0H3.284a1.909 1.909 0 00-1.8 1.871v3.457a1.822 1.822 0 001.8 1.757h.47V9.11h-.93A2.809 2.809 0 000 11.626v16.238a2.912 2.912 0 002.821 2.621h13.77l-.2-.2a5.734 5.734 0 01.001-8.1zm-5.02-1.495v2.984a.893.893 0 11-1.786 0V20.69H6.602a.893.893 0 010-1.786h2.982V15.92a.893.893 0 111.786 0v2.98h2.984a.893.893 0 110 1.786zM29.33 17.963l-.308-.308a3.946 3.946 0 00-5.574 0l-2.2 2.2 5.882 5.882 2.2-2.2a3.946 3.946 0 000-5.574z"
        fill="#ff7b16"
      />
      <path
        d="M17.655 23.446a3.946 3.946 0 000 5.574l.308.308a3.946 3.946 0 005.574 0l2.331-2.331-5.882-5.882z"
        fill="#ff7b16"
      />
    </svg>
  );
}

export default MedSvg;
